import React from "react";
import { Fade } from "react-awesome-reveal";
import "../styles/Promo.scss";

export const Promo = () => {
        const getLastDayOfMonth = () => {
            const today = new Date();
            const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
            
            return new Intl.DateTimeFormat("es-ES", {
              day: "numeric",
              month: "long",
              year: "numeric",
            }).format(lastDay);
        };
  return (
    <div className="promoContainerMain d-flex justify-content-center align-items-center">
      <div className="row promoContainer d-flex justify-content-center align-items-center">
        <div className="textPromo col-md-7 d-flex justify-content-center align-items-center flex-column">
          <span className="textPromoFirst">
            "¡Inscríbete hoy y olvídate de la inscripción!&nbsp;
            <span className="textPromoSecond">
            Chatea con nuestro bot y realiza tu registro."
            </span>
          </span>
          <span className="ofertaText">Oferta válida hasta el {getLastDayOfMonth()}. </span>
        </div>
        <div className="buttonPromo col-md-5 d-flex justify-content-center align-items-center">
        <Fade direction="left"><a href="#formContact" className="btn btnPromo">Empieza hoy</a></Fade>
        </div>
      </div>
    </div>
  );
};

export default Promo;
